import Reels from './Reels';
import ReelsSkeleton from './Reels.skeleton';

export default function Component(props) {
    const { isLoading } = props;
    return isLoading ? <ReelsSkeleton {...props} /> : <Reels {...props} />;
}
